module.exports = __webpack_public_path__ + "img/orga-logo-full.de6bb2f8.png";